import createIcon from '../../createIcon';

/**
 * @component @name Contrast
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMjJDMTcuNTIgMjIgMjIgMTcuNTIgMjIgMTJDMjIgNi40OCAxNy41MiAyIDEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMlpNMTMgNC4wN0MxNi45NCA0LjU2IDIwIDcuOTIgMjAgMTJDMjAgMTYuMDggMTYuOTUgMTkuNDQgMTMgMTkuOTNWNC4wN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Contrast = createIcon('Contrast', [
  [
    'path',
    {
      d: 'M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM13 4.07C16.94 4.56 20 7.92 20 12C20 16.08 16.95 19.44 13 19.93V4.07Z',
      key: 'vu1unl',
    },
  ],
]);

export default Contrast;
